import { memo, useMemo, useState, useEffect, useCallback } from "react";
import { getMutualFundHoldings, getMutualFund, getNfo, getThemes, getSummary } from "../../../redux/actions/mutualFund";
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from "react-bootstrap";
import { BzTabs, BzTabsContainer, BzTab, BzChip, BzInputText } from "../../../components";
import { Holdings, Watchlist, Orders } from "../../../containers";
import Summary from "./Summary";
import HoldingSummary from './HoldingSummary';
import OrderWatchListPopOver from "../../OrderWatchListPopOver";
import { handleModal } from "../../../redux/actions/modals";
import { toastConfig } from "../../../redux/actions/toast";
import { MUTUALFUND_WATCHLIST_TABS_MENUS, MF_WATCHLIST_GRID_INDEX, MF_MY_CORNER_TABS } from "../../../utils/global_variables";
import { MUTUAL_FUNDS_WATCHLIST_GRID } from "../../../utils/global_functions";

const arrKababDropdown = [
    { id: '0', value: '0', content: 'Add funds' },
    { id: '1', value: '1', content: 'Remove Funds' },
    { id: '2', value: '2', content: 'Reorder Funds' },
    { id: '3', value: '3', content: 'Rename Watchlist' },
    { id: '4', value: '4', content: 'Share Watchlist' },
    { id: '5', value: '5', content: 'Delete  Watchlist' },
];

const holdingsMenu = [
    { label: 'Fund Overview', icon: 'icon-overview' },
    { label: 'Transaction Information', icon: 'icon-info' },
    { label: 'Transact', icon: 'icon-edit' },
];


const MyCorner = ({ onMfWatchlistGridRowDragEnd, mutualFundsScrips, arrMutualFundWatchlistColDefs, isToastToggle, setIsToastToggle, props }) => {
    const dispatch = useDispatch();

    const [activeTabMyCorner, setActiveTabMyCorner] = useState(MF_MY_CORNER_TABS.WATCHLIST);
    const [toasterMsgConfig, setToasterMsgConfig] = useState({ isShow: false, isButton: false, msg: 'Funds reordered successfully', btnContent: 'ok' });
    const [deleteWatchList, setDeleteWatchList] = useState(false);
    const [removeFunds, setRemoveFunds] = useState(false);
    const [showRemoveFundModal, setShowRemoveFundModal] = useState(false);
    const [currentWatchListName, setCurrentWatchListName] = useState('');
    const [arrWatchlist, setArrWatchlist] = useState([]);
    const [fundList, setFundList] = useState([]);
    const [isSuppressMenu, setIsSuppressMenu] = useState(true);
    const [activeFilters, setActiveFilters] = useState({});
    const [isreorderWatchlist, SetreorderWachlist] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);


    const handleFiltersOnClick = useCallback((filterName, filterValue) => {
        setActiveFilters(curr => { return { ...curr, [filterName]: filterValue }; });

    }, []);


    const handleDelete = useCallback((te, i) => {

        selectedValue.splice(i, 1);
        setSelectedValue([...selectedValue]);

    }, [selectedValue]);
    const [isselected, setSelected] = useState([]);
    const ExtendHolding = useMemo(() => HoldingSummary, []);
    const holdings = useSelector(state => state.mutualFund.holdings);
    const themes = useSelector(state => state.mutualFund.themes);
    const nfo = useSelector(state => state.mutualFund.nfo);
    const mutualFund = useSelector(state => state.mutualFund.mutualFund);
    const watchList = useSelector(state => state.mutualFund.watchList);
    const portfolioSumaary = useSelector(state => state.mutualFund.portfolioSumaary);

    const GridHeaderSearch = ({ className, ...props }) => {
        return <BzInputText size="sm" className={`${className} scripname-searchtext`} type='search' placeholder='Search Funds' />;
    };

    // const companyNameForamtter = (params) => {
    //     return (<>
    //         <div className='font-medium font-size4 color-text ms-3 text-uppercase'>{params.data.fundName}</div>
    //         <div className='chips-wrap flex-wrap'>
    //             {
    //                 params?.data?.category?.map((category, index) =>
    //                     <BzChip key={index} className='chips primary-chip font-medium font-size2 text-uppercase me-2 mb-2'>{category}</BzChip>)}
    //         </div>
    //     </>);
    // };


    const getCellRendererParams = (props) => {
        return {
            placement: 'right',
            title: props?.data?.fund, isBzChip: true, bzChipData: props?.data?.fundCategory, nav: props?.data?.nav, colLeft: 8, colRight: 4,
            children: <div className='scrip-wrap'>
                <div className='normal-scrip dontmiss-scrip'></div>
                <div className='align-items-center'>
                    <div className='font-medium font-size4 color-text text-uppercase ms-2'>{props?.data?.fund}</div>
                    <div className='chips-wrap flex-wrap'>
                        {props.data.fundCategory.map((category, index) =>
                            <BzChip key={index} className='chips primary-chip font-medium font-size2 text-uppercase ms-2 mb-2'>{category}</BzChip>)}
                    </div>
                    <span className='font-regular font-size4 color-subtext'>24 AUG 120</span>
                    <span className='font-regular font-size4 color-subtext ms-2'>EQ</span>
                    <span className='icon-16 icon-dontmiss icon-yellow ms-2'></span>
                    <span className='icon-16 icon-portfolio icon-dark ms-2'></span>
                </div>
            </div>,
            bodyData: holdingsMenu
        };
    };

    const btnClickHandler = () => {
        if (isreorderWatchlist) {

            MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.setGridOption('rowDrag', false);

        }
        if (removeFunds) {

            setShowRemoveFundModal(true);
        }
        if (deleteWatchList) {
            dispatch(handleModal([{ "DELETE_WATCHLIST": false }]));
        }

        setToasterMsgConfig(curr => { return { ...curr, isShow: false, isButton: false }; });

    };



    const [arrOptionChainColDefs, setArrOptionChainColDefs] = useState(
        [
            { field: 'first', headerName: "", cellRenderer: 'agGroupCellRenderer' },

            {
                field: 'fund', headerName: 'fund', headerComponent: GridHeaderSearch, cellRenderer: OrderWatchListPopOver, cellRendererParams: getCellRendererParams, width: 800
            },
            { field: 'inv', headerName: 'INV. VAL', },
            { field: 'curr', headerName: 'CURR. VAL' },
            { field: 'overall', headerName: 'OVERALL P/L' },
            { field: 'todays', headerName: 'TODAYS P/L' },
            { field: 'units', headerName: 'UNITS' },
            { field: 'blocked', headerName: 'BLOCKED UNIT' },
            { field: 'folio', headerName: 'FOLIO/DP' },



        ]);

    const onRowSelected = useCallback((row) => {
        if (isToastToggle) {
            dispatch(toastConfig({ renderSingle: true, show: true, message: `Remove funds ${MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.getSelectedRows().length} `, button: [{ btnName: "Close", type: 'CLOSE_REMOVING_MF_FUNDS', className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_MF_FUNDS", className: "btn btn-outline-active ms-3" }] }));
        } else { }
    }, [isToastToggle, dispatch]);

    const handleAddFunds = () => {
        dispatch(handleModal([{ "CREATE_CUSTOM_WATCHLIST": true }]));
        setCurrentWatchListName(watchList?.name);
    };

    const onRemoveFunds = () => {
        setIsToastToggle(true);
        MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.setGridOption('rowDrag', false);
        MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api.forEachNode((node) => {
            node.setSelected(true);
        });
        MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.setColumnVisible(MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.columnModel?.columnDefs[0]?.colId, true);
        dispatch(toastConfig({ show: true, message: `Remove funds ${MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.getSelectedRows().length} `, button: [{ btnName: "Close", type: 'CLOSE_REMOVING_MF_FUNDS', className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_MF_FUNDS", className: "btn btn-outline-active ms-3" }] }));
    };

    const kababDropdownoptionsOnClickHandler = useCallback((e, value) => {

        switch (value) {

            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .CREATE_NEW_WATCHLIST:
                handleAddFunds();
                break;
            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .REMOVE_WATCHLIST:
                onRemoveFunds();
                break;

            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .REORDER_WATCHLIST:
                onReorderFunds();
                break;

            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .RENAME_WATCHLIST:
                dispatch(handleModal([{ "RENAME_WATCHLIST": true }]));
                break;

            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .SHARE_WATCHLIST:
                break;

            case MUTUALFUND_WATCHLIST_TABS_MENUS
                .DELETE_WATCHLIST:
                dispatch(handleModal([{ "DELETE_WATCHLIST": true }]));
                break;

            default: ;
        }
    }, []);

    const [gridRowDrag] = useState(true);
    useEffect(() => {
        if (MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api) {
            MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.setGridOption('rowDrag', gridRowDrag);
        }
    }, [gridRowDrag]);

    const onGridReady = useCallback((params) => {
        params?.api?.setGridOption('rowDrag', false);
    }, []);

    const onReorderFunds = useCallback(() => {
        const arrCurrColumnDefs = MUTUAL_FUNDS_WATCHLIST_GRID.current.api.columnModel.columnDefs;
        const objRowDragColumn = arrCurrColumnDefs.find(column => column.field === MF_WATCHLIST_GRID_INDEX.SYMBOL);
        if (objRowDragColumn) {
            MUTUAL_FUNDS_WATCHLIST_GRID.current.api.setGridOption('rowDrag', true);
            MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api.forEachNode((node) => {
                node.setSelected(true);
            });
            MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.setColumnVisible(MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.columnModel?.columnDefs[0]?.colId, false);
            setTimeout(() => {
                dispatch(toastConfig({ show: true, message: `Reorder scrips in ${watchList?.name}`, button: [{ btnName: "Done", type: "REORDER_MF_FUNDS", className: "btn btn-outline-active ms-3" }] }));
            }, 50);
        } else { }
    }, [watchList, dispatch]);

    const handleOnFilterApply = () => {
        setSelectedValue(Object.values(activeFilters));
        dispatch(handleModal([{ "FILTER_MODAL": false }]));
        setActiveFilters({});
    };

    useEffect(() => {
        dispatch(getMutualFundHoldings());
        dispatch(getMutualFund());
        dispatch(getNfo());
        dispatch(getThemes());
        dispatch(getSummary());
    }, [dispatch]);

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col>
                        <Summary portfolioSumaary={portfolioSumaary} />
                    </Col>
                </Row>
                <Row className='g-0 pt-3'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='horizontal-scroll-wrap'>
                            <BzTabs className='nav nav-tabs'>
                                <BzTab isActive={activeTabMyCorner === MF_MY_CORNER_TABS.HOLDINGS} tabKey={MF_MY_CORNER_TABS.HOLDINGS} onClick={() => setActiveTabMyCorner(MF_MY_CORNER_TABS.HOLDINGS)} className='nav-link text-capitalize'>
                                    Holdings
                                </BzTab>
                                <BzTab isActive={activeTabMyCorner === MF_MY_CORNER_TABS.ORDERS} tabKey={MF_MY_CORNER_TABS.ORDERS} onClick={() => setActiveTabMyCorner(MF_MY_CORNER_TABS.ORDERS)} className='nav-link text-capitalize'>
                                    Orders
                                </BzTab>
                                <BzTab isActive={activeTabMyCorner === MF_MY_CORNER_TABS.WATCHLIST} tabKey={MF_MY_CORNER_TABS.WATCHLIST} onClick={() => setActiveTabMyCorner(MF_MY_CORNER_TABS.WATCHLIST)} className='nav-link text-capitalize'>
                                    WatchList
                                </BzTab>
                            </BzTabs>
                        </div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='icon-16 icon-expand icon-dark ms-3'>&nbsp;</div>
                    </Col>
                </Row>
                <Row className='g-0 pt-4'>
                    <Col>
                        <BzTabsContainer>
                            {
                                activeTabMyCorner === MF_MY_CORNER_TABS.HOLDINGS ?
                                    <Holdings portfolioSumaary={portfolioSumaary} ExtendHolding={ExtendHolding} holdings={holdings}
                                        isMasterDetail
                                        arrOptionChainColDefs={arrOptionChainColDefs} activeFilters={activeFilters}
                                        setActiveFilters={setActiveFilters}
                                        handleDelete={handleDelete}
                                        handleFiltersOnClick={handleFiltersOnClick}
                                        selectedValue={selectedValue}
                                        handleOnFilterApply={handleOnFilterApply} />
                                    : (
                                        activeTabMyCorner === MF_MY_CORNER_TABS.HOLDINGS ?
                                            <Orders isSuppressMenu={isSuppressMenu} setIsSuppressMenu={setIsSuppressMenu} />
                                            : (
                                                activeTabMyCorner === MF_MY_CORNER_TABS.WATCHLIST ?
                                                    <Watchlist
                                                        onMfWatchlistGridRowDragEnd={onMfWatchlistGridRowDragEnd} mutualFund={mutualFund} nfo={nfo} themes={themes}
                                                        mutualFundsScrips={mutualFundsScrips} fundList={fundList} setFundList={setFundList} currentWatchListName={currentWatchListName}
                                                        setCurrentWatchListName={setCurrentWatchListName} arrWatchlist={arrWatchlist} setArrWatchlist={setArrWatchlist} activeFilters={activeFilters} setActiveFilters={setActiveFilters}
                                                        selectedValue={selectedValue} handleFiltersOnClick={handleFiltersOnClick} handleOnFilterApply={handleOnFilterApply}
                                                        isselected={isselected} setSelected={setSelected} arrKababDropdown={arrKababDropdown} kababDropdownoptionsOnClickHandler={kababDropdownoptionsOnClickHandler}
                                                        isreorderWatchlist={isreorderWatchlist} SetreorderWachlist={SetreorderWachlist} removeFunds={removeFunds}
                                                        setRemoveFunds={setRemoveFunds} toasterMsgConfig={toasterMsgConfig} setToasterMsgConfig={setToasterMsgConfig}
                                                        showRemoveFundModal={showRemoveFundModal} setShowRemoveFundModal={setShowRemoveFundModal} onGridReady={onGridReady}
                                                        btnClickHandler={btnClickHandler} onRowSelected={onRowSelected} onRemoveFunds={onRemoveFunds} handleAddFunds={handleAddFunds}
                                                        arrMutualFundWatchlistColDefs={arrMutualFundWatchlistColDefs}
                                                    />
                                                    : null
                                            )
                                    )
                            }
                        </BzTabsContainer>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default memo(MyCorner);
